import React from 'react'

const Adress = () => {
  return (
    <div>Adress</div>
  )
}

export default Adress